import { config } from 'src/config/config';
import { i18n } from 'src/i18n';
import { NavigationService } from 'src/services/navigation-service';
import { OrderStep, ProductDetailsPage } from 'src/state/order/types';

export interface Breadcrumb {
  text: string;
  path: string;
}

export interface Breadcrumbs {
  externalBreadcrumbs: Breadcrumb[];
  internalBreadcrumbs: Breadcrumb[];
}

export const isFirstInternalBreadcrumb = (path: string, breadcrumbs: Breadcrumb[]): boolean =>
  breadcrumbs.length !== 0 && breadcrumbs[0].path === path;

export const getBreadcrumbs = (
  path: string,
  page: ProductDetailsPage,
  eligibleToUpgrade: boolean,
  eligibleToPurchase: boolean,
): Breadcrumbs => {
  const internalBreadcrumbs: Breadcrumb[] = [];

  if (eligibleToUpgrade && eligibleToPurchase) {
    internalBreadcrumbs.push({
      path: NavigationService.PRODUCT_SELECT,
      text: i18n.component.breadcrumbs.store,
    });
  }

  if (
    path === NavigationService.PRODUCT_PURCHASE ||
    (path === NavigationService.SUMMARY && page === OrderStep.PURCHASE_DECODER)
  ) {
    internalBreadcrumbs.push({
      text: i18n.component.breadcrumbs.purchaseDecoder,
      path: NavigationService.PRODUCT_PURCHASE,
    });
  }

  if (
    path === NavigationService.PRODUCT_UPGRADE ||
    (path === NavigationService.SUMMARY && page === OrderStep.UPGRADE_DECODER)
  ) {
    internalBreadcrumbs.push({
      text: i18n.component.breadcrumbs.upgradeDecoder,
      path: NavigationService.PRODUCT_UPGRADE,
    });
  }

  if (path === NavigationService.SUMMARY) {
    internalBreadcrumbs.push({
      text: i18n.component.breadcrumbs.cart,
      path: NavigationService.SUMMARY,
    });
  }

  return {
    externalBreadcrumbs: [
      {
        text: i18n.component.breadcrumbs.frontPage,
        path: config.MINE_SIDER,
      },
    ],
    internalBreadcrumbs,
  };
};
